module.exports = __webpack_public_path__ + "img/main-icon-3.5bbad478.svg";